/* global axios */
import ApiClient from './ApiClient';

class OperationalReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true });
  }

  getDashboard(params = {}) {
    return axios.get(`${this.url}/dashboard`, { params });
  }

  getTeams(params = {}) {
    return axios.get(`${this.url}/teams`, { params });
  }

  getTeam(teamId, params = {}) {
    return axios.get(`${this.url}/teams/${teamId}`, { params });
  }

  getAgents(params = {}) {
    return axios.get(`${this.url}/agents`, { params });
  }

  getAgent(agentId, params = {}) {
    return axios.get(`${this.url}/agents/${agentId}`, { params });
  }

  createExport(payload) {
    return axios.post(`${this.url}/exports`, payload);
  }

  getExportStatus(jobId) {
    return axios.get(`${this.url}/exports/${jobId}`);
  }
}

export default new OperationalReportsAPI();
